<script setup>
import { __ } from '@/utils';
import { Field, ErrorMessage } from 'vee-validate';

const checkboxInputs = [
{
	id: 'terms',
	value: `<span>${__('I have read and confirm the details of the order, and the terms of engagement detailed in the regulations of the services I ordered')} <a href="${theme_path.url}/resources/pdf/legal-doc.pdf" target="_blank"> ${__('and in the general conditions')}</a>, ${__('in all my subscriptions. Also, I agree to receive inquiries and marketing messages from Exphon and its business partners by phone and by any means of mailing. I understand that I can request removal at any time.')}</span>`
},
]
</script>
<template>
	<div class="confirms confirms--small-margin">
		<template v-for="checkbox in checkboxInputs">
			<div class="checkbox checkbox--small checkbox--green">
				<Field type="checkbox" :name="checkbox.id" :value="true" :id="checkbox.id" />

				<label :for="checkbox.id" v-html="checkbox.value" />
				<ErrorMessage :name="checkbox.id"  as="span" class="error" />
			</div><!-- /.checkbox -->
		</template>
	</div><!-- /.confirms -->
</template>